/* wsapi3-placeholders v1.0 */
/* Deploy Version 2026-09-24 21:28:06 */
/* Deploy Version 2026-09-24 19:11:13 */
/* Deploy Version 2026-07-27 16:11:02 */
wsMain.createModule({
  name: 'placeholders',
  version: '1.0',
  updatedAt: '2026-07-14',
  function: 'create',
  subFunctions: {
    fabricantes() {
      if (wsMain.placeHolders.fabricantes.qtd > 0) {
        let tags = document.querySelectorAll('[data-wsjs-module=fabricantes]');
        tags.forEach(tag => {
          // Já veio pronto do servidor — tem o tamanho real, não o palpite genérico daqui.
          if (tag.hasAttribute('data-ws-rendered')) return;
          tag.setAttribute('data-wsholder', 'true');
          tag.style.minHeight = wsMain.placeHolders.fabricantes.height;
        });
      }
    },
    condicoes() {
      if (wsMain.placeHolders.condicoes.qtd > 0) {
        let tags = document.querySelectorAll('[data-wsjs-module=conditions]');

        tags.forEach(tag => {
          if (tag.hasAttribute('data-ws-rendered')) return;
          tag.setAttribute('data-wsholder', 'true');
          tag.style.minHeight = wsMain.placeHolders.condicoes.height;
        });
      }
    },
    banners() {
      placeholderHome.banners.forEach(banner => {
        try {
          let defaultHeight = wsMain.placeHolders.banners[banner.regiao.toLowerCase()]?.height;
          let heightToUse = banner.altura == 0 || !banner.altura ? defaultHeight : banner.altura;

          document.querySelectorAll(`*[data-wsjs-banner="${banner.regiao.toLowerCase()}"]`).forEach(tag => {
            if (tag.hasAttribute('data-ws-rendered')) return;
            tag.setAttribute('data-wsholder', 'true');
            tag.style.minHeight = heightToUse;
          });
        } catch(_) {}
      });
    },
    grupos() {
      return;
      if (wsMain.placeHolders.grupos.qtd > 0) {
        let heightSet = parseInt(wsMain.placeHolders.grupos?.height)*wsMain.placeHolders.grupos.qtd;
        let heightToUse = wsMain.placeHolders.grupos?.height.replace(/([0-9]{0,})/, heightSet);

        document.querySelectorAll(`[data-wsjs-prod-list]`).forEach(tag => {
          if (tag.getAttribute('data-wsjs-prod-list') != 'previous' && tag.getAttribute('data-wsjs-prod-list') != 'home' && tag.getAttribute('data-wsjs-prod-list') != 'spotlight') {
            tag.setAttribute('data-wsholder', 'true');
            tag.setAttribute('data-lazyheight', wsMain.placeHolders.grupos?.height);
            tag.style.minHeight = heightToUse;
          }
        });
      }
    },
    produtos() {

    }
  },
  async create() {
    try {
      if (wsMain.placeHolders) {
        Object.keys(wsMain.modules['placeholders'].subFunctions).forEach(async holder => {
          try {
            await wsMain.modules['placeholders'].subFunctions[holder]();
          } catch(err) {
            console.log(err);
          }
        });
      }

      try {
        document.querySelector('[data-wsjs-loader]').style.display = 'block';      
      } catch(err) {}
      
      return true;
    } catch(err) {
      console.log(err)
      return false;
    }
  }
});
